export const POSITIONS_HELD = {
  BACKEND_DEVELOPER: 'Backend Developer',
  BUSINESS_ANALYST: 'Business Analyst',
  BACKEND_ENGINEER: 'Back-end engineer',
  CEO: 'CEO',
  CFO: 'CFO',
  CIO: 'CIO',
  COO: 'COO',
  CO_FOUNDER: 'co-founder',
  CTO: 'CTO',
  DESIGNER_UI_UX: 'Designer UI-UX',
  FOUNDER: 'founder',
  FULL_STACK_ENGINEER: 'Full-stack engineer',
  FRONTEND_ENGINEER: 'Front-end engineer',
  HEAD_OF_SALES: 'Head of Sales',
  LEAD_BACKEND_ENGINEER: 'Lead Back-end engineer',
  LEAD_FRONTEND_ENGINEER: 'Lead Front-end engineer',
  PROJECT_MANAGER: 'Project Manager',
  QUALITY_ASSURANCE_ENGINEER: 'Quality Assurance Engineer',
  REACT_DEVELOPER: 'React Developer',
  REACT_NATIVE_ENGINEER: 'React Native Engineer',
  SENIOR_BACKEND_ENGINEER: 'Senior Back-end engineer',
  SENIOR_FRONTEND_ENGINEER: 'Senior Front-end engineer',
  SOFTWARE_DEVELOPER: 'Software developer',
  VR_AR_ENGINEER: 'VR/AR engineer',
}
